/**
 * Hastanın memnuniyet anketi sayfasının genel yolu: `${origin}${SURVEY_PATH}/${belirteç}`
 * (kabuk dışı; belirteç API ve Caddy günlüklerinde maskelenir).
 *
 * **Tek kaynak (H20, onam ve ödeme yollarının aynısı).** Bağlantıyı SUNUCU kurar (Meta şablonunun
 * URL düğmesi, `meta-templates.ts`), adresi WEB çözer (`app/routes.ts` `parseSurveyPath`).
 *
 * Bu dosyaya zod (ya da zod'a dokunan bir modül) import ETME: rota tablosu giriş grafiğindedir ve
 * sabit `surveys.ts`teki şemalarla aynı modülde dururken onları da giriş paketine çekerdi
 * (`payments-path.ts`te ölçülmüş gerekçe, −24,72 kB).
 */
export const SURVEY_PATH = '/anket';
/**
 * Hastanın yorumunun üst sınırı. Şema (`surveys.ts`) ile sayfanın `maxLength`/sayacı AYNI sabiti
 * okur; burada durur ki sayfa sınırı öğrenmek için zod şemalarını paketine çekmesin.
 */
export const SURVEY_COMMENT_MAX = 1000;
//# sourceMappingURL=surveys-path.js.map